/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guarantee_Heading_2Inputs */

const et_guarantee_heading_2 = /** @type {(inputs: Guarantee_Heading_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meie riskime, mitte teie.`)
};

const en_guarantee_heading_2 = /** @type {(inputs: Guarantee_Heading_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We take the risk, not you.`)
};

/**
* | output |
* | --- |
* | "We take the risk, not you." |
*
* @param {Guarantee_Heading_2Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const guarantee_heading_2 = /** @type {((inputs?: Guarantee_Heading_2Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guarantee_Heading_2Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_guarantee_heading_2(inputs)
	return en_guarantee_heading_2(inputs)
});